import { Component, Input, OnInit } from '@angular/core';
import { SortingService } from '@app/shared/components/grid/sorting-service';

@Component({
  selector: 'app-multi-header-table',
  templateUrl: './multi-header-table.component.html',
  styleUrls: ['./multi-header-table.component.scss'],
  standalone: false,
})
export class MultiHeaderTableComponent implements OnInit {
  @Input() tableData: any;
  @Input() searchText: string;
  @Input() configurations: any;
  // @Output() scrollEnd: EventEmitter<any> = new EventEmitter<any>();

  public tbody: any = [];
  public mainHeader = [];
  public subHeader = [];
  public mainHeaderConfiguration = [];
  public subHeaderConfiguration = [];
  public tableConfiguration = [];

  basedOn = 'geography_level';
  index = 0;
  headerType = 'mainHeader';

  constructor(private sortingService: SortingService) {}

  ngOnInit(): void {
    this.initializeTable();
    setTimeout(() => {
      this.adjustPadForScroll();
    });
  }

  adjustPadForScroll(): void {
    const elements = document.getElementsByClassName('multi-header-table');

    if (elements.length && this.tbody.length) {
      // Convert HTMLCollection to Array
      Array.from(elements).forEach(ele => {
        const tableContainer = ele.querySelector('.table-body-content') as HTMLElement;
        const headerElement = ele.querySelector('.table-header-content') as HTMLElement;

        if (!tableContainer || !headerElement) {
          return;
        }

        const scrollHeight = tableContainer.scrollHeight;
        const clientHeight = tableContainer.clientHeight;

        if (scrollHeight > clientHeight) {
          const scrollWidth = tableContainer.offsetWidth - tableContainer.clientWidth;
          headerElement.setAttribute('style', `width: calc(100% - ${scrollWidth}px) !important`);
        } else {
          headerElement.setAttribute('style', 'width: 100%');
        }
      });
    }
  }

  initializeTable(): void {
    this.mainHeader = this.configurations.mainHeader;
    this.mainHeaderConfiguration = this.configurations.mainHeaderConfiguration;
    this.subHeader = this.configurations.subHeader;
    this.subHeaderConfiguration = this.configurations.subHeaderConfiguration;
    this.tableConfiguration = this.configurations.tableConfiguration;
    this.tbody = this.tableData;
    this.sortTableContent(this.basedOn, this.index, this.headerType);
  }

  sortTableContent(basedOn: string, index: number, headerType: string): void {
    this.basedOn = basedOn;
    this.index = index;
    this.headerType = headerType;

    if (this.tbody && this.tbody.length) {
      let itemConfig;
      if (headerType === 'mainHeader') {
        itemConfig = this.mainHeaderConfiguration[index];
      } else {
        itemConfig = this.subHeaderConfiguration[index];
      }
      if (itemConfig.isSortable) {
        if (itemConfig.sortOrder === 'ASC') {
          itemConfig.sortOrder = 'DSC';
          this.sortingService.commonReverseSortByKey(this.tableData, basedOn, itemConfig.isNumber);
        } else {
          itemConfig.sortOrder = 'ASC';
          this.sortingService.commonSortByKey(this.tableData, basedOn, itemConfig.isNumber);
        }
        this.resetSort(basedOn);
      }
    }
  }

  resetSort(exceptFor?: string): void {
    if (exceptFor) {
      this.mainHeaderConfiguration.forEach(el => {
        if (el.id !== exceptFor) {
          el.sortOrder = '';
        }
      });
      this.subHeaderConfiguration.forEach(el => {
        if (el.id !== exceptFor) {
          el.sortOrder = '';
        }
      });
    } else {
      this.mainHeaderConfiguration.forEach(el => {
        el.sortOrder = '';
      });
      this.subHeaderConfiguration.forEach(el => {
        el.sortOrder = '';
      });
    }
  }

  // Scroll Event Emitter
  onScrollEnd(): void {
    // this.scrollEnd.emit();
  }
}
